import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { LIST_LOGS_INIT } from '../../actionTypes';
import { listLogsSuccess, errorLogs } from './actions';
import { listarLogs } from 'src/integracoes/servicos/pgloader/funcoes/logs';
import { FarmaError } from 'src/integracoes/modelos/erros';
import { ILog } from 'src/integracoes/servicos/pgloader/modelos/ILog';

// --------------------------- Listar logs ---------------------------------------------------------

const fetchListarLogs = async (machine_id: string) => {
  try {
    const { status, dados, mensagem } = await listarLogs(machine_id);
    if (status && Array.isArray(dados)) {
      return { isError: false, logs: dados as ILog[], errorMessage: null };
    }
    return { isError: true, logs: [] as ILog[], errorMessage: mensagem || 'Erro ao listar logs' };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseListarLogs({ payload }: any) {
  try {
    const { isError, logs, errorMessage } = yield call(fetchListarLogs, payload);
    if (!isError) {
      yield put(listLogsSuccess(logs));
    } else {
      yield put(errorLogs({ msg: errorMessage }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(errorLogs({ msg: mensagem }));
  }
}

function* watchListarLogs() {
  yield takeEvery(LIST_LOGS_INIT, parseListarLogs);
}

export default function* logsSaga() {
  yield all([fork(watchListarLogs)]);
}
